import Vue from 'vue'
import Router from 'vue-router'
import { hasIntersect } from '@common/js/common'
import { routes } from '../js/menu.js' // TODO absolute path
import store from '../vuex/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: routes,
})

let goToNext = (to, next, router) => {
  const vm = router.app
  if (!Array.isArray(to.meta.permList)) {
    next()
    Vue.prototype.setTitle(to.meta.title)
  } else {
    if (hasIntersect(to.meta.permList, vm.$store.state.settings.permList)) {
      next()
      Vue.prototype.setTitle(to.meta.title)
    } else {
      router.push('/')
    }
  }
  store.commit('ACTIVE_MENU', to.path)
}

router.beforeEach((to, from, next) => {
  const vm = router.app
  let ignore = ['/login', '/register', '/aff-login', '/reset-psw', '/user-verify', '/token-invalid']
  if (~ignore.indexOf(to.path)) {
    document.title = to.name ? `Youmi Offers | ${to.name}` : 'Youmi Offers'
    next()
  } else {
    if ((!vm._isMounted && to.name !== 'login') || from.name === 'login' || (!vm._isMounted && to.name !== 'aff-login') || from.name === 'aff-login') {
      vm.$options.store.dispatch('getPerm').then(() => {
        goToNext(to, next, router)
      })
    } else {
      goToNext(to, next, router)
    }
  }
})

export default router
